import moment from "moment";

export default function CreateDomesticCMVWorkItemModel(mergedData) {
  return {
    workorderid: mergedData.id,
    cmvduedate: mergedData.cmvDueDate,
    cmvcontactdate: mergedData.cmvContactDate,
    projectid: mergedData.projectId,
    projectname: mergedData.projectName,
    siteid: mergedData.siteId,
    sitename: mergedData.siteName,
    propertyid: mergedData.propertyId,
    propertyname: mergedData.propertyName,
    propertynumber: mergedData.propertyNumber,
    customerresidentname: mergedData.customername,
    customercontactnumber: mergedData.customerphone,
    customervulnerability: mergedData.customervulnerability,
    customerid: mergedData.customerId,
    customername: mergedData.clientName,
    territoryid: mergedData.territoryId,
    territoryname: mergedData.territoryName,
    workitemtemplateid: mergedData.workitemtemplateid,
    workitemtemplateref: mergedData.workitemtemplateref,
    preferredappointmentdate: moment(
      mergedData.preferredAppointmentDate
    ).toISOString(),
    preferredappointmenttimeslot: mergedData.preferredAppointmentSlot,
    preferredappointmenttimeslottitle: mergedData.preferredAppointmentSlotTitle,
    workitemagreement: mergedData.appointmentConfirmed,
    workitemagreementtitle: mergedData.appointmentConfirmedTitle,
    jobspecificaccessnotes: mergedData.jobSpecificAccessNotes,
    propertyaccessnotes: mergedData.propertyaccessnotes,
    redflag: mergedData.redflag,
    idempotencyGuid: mergedData.idempotencyGuid,
    createdBy: mergedData.createdBy,
    noAccessattempts: mergedData.noAccessAttempts,
  };
}
